export default "__VITE_ASSET__2eK8DpUW__"